import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login, registrationStatus } from '../api/authApi';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [registrationMode, setRegistrationMode] = useState('open');
  const { storeTokens } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadRegistrationMode = async () => {
      try {
        const { data } = await registrationStatus();
        setRegistrationMode(data.mode || 'open');
      } catch {
        setRegistrationMode('open');
      }
    };

    loadRegistrationMode();
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const { data } = await login(form);
      storeTokens(data.accessToken, data.refreshToken, data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="auth-page">
      <img
        src="/necronomicon_game_logo_1995.svg"
        alt="Necronomicon game logo"
        className="auth-logo"
      />
      <h1>Necronomicon</h1>
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>Login</h2>
        {error && <p className="error">{error}</p>}
        <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
        <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required />
        <button type="submit">Enter</button>
        {registrationMode === 'open' ? (
          <p>
            No account? <Link to="/register">Register</Link>
            <br />
            <Link to="/forgot-password">Forgot password?</Link>
          </p>
        ) : (
          <p>
            Beta access is invite-only. Use your invite link to register.
            <br />
            <Link to="/forgot-password">Forgot password?</Link>
          </p>
        )}
      </form>
    </div>
  );
};

export default LoginPage;
